import React from 'react';
import styles from './style.js';
import { withStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import MUTypography from '../ui/MUTypography';
import classNames from 'classnames';

class BasicPageComponent extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    const { classes } = this.props;

    return (
      <div className = {classNames(classes.container, 'CustomBasicPageComponent')}style={{minHeight: window.screen.height}} >
        <div className = {classes.intro} >
          <MUTypography paragraph={true} className={_.isNil(this.props.title)?classes.noTitle:classes.title}>
            {this.props.title}
          </MUTypography>
          <MUTypography paragraph={true} className={classes.description}>
            {this.props.description}
          </MUTypography>
        </div>
        <div className = {classNames(classes.body, 'CustomBasicPageComponentBody')}>
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(BasicPageComponent);

